import React, { Component } from 'react';
import * as d3 from 'd3';

class Sparkline extends Component {
  static defaultProps = {
    className: '',
  }

  node = null;

  componentDidMount() {
    this.renderLine(this.props.data);
  }

  setSourceNode = node => {
    this.node = node;
  };

  // Fit all X values into specific width
  setX = (dataCount, width) => d3.time.scale().domain([0, dataCount]).range([0, width]);

  // Fit all Y values into specific height
  setY = (data, height) => {
    const min = Math.min(...data);
    const max = Math.max(...data);
    
    return d3.scale.linear().domain([min, max]).range([height, 0]);
  };

  renderLine = (data) => {
    const { height, width } = this.node.getBoundingClientRect();
    const x = this.setX(data.length, width);
    const y = this.setY(data, height);
    const line = d3.svg.line()
      .x((d,i) => x(i))
      .y((d) => y(d))

    const graph = d3.select(this.node).append('svg:svg');
    graph.attr('width', width).attr('height', height);
    graph.append("svg:path").attr('d', line(data));
  }

  render() {
    const className = ['sparkline', this.props.className].join(' ');
    return (
      <div className={className} ref={this.setSourceNode} />
    )
  }
}

export default Sparkline;



// WEBPACK FOOTER //
// ./src/Sparkline/index.js